/* eslint no-alert: 0 */

export default class ErrorHelpers {
  static showErrors(target, errors, prefix) {
    $(target)
      .find('.form-group span.error-message')
      .remove();
    Object.entries(errors).forEach(entry => {
      const [attr, messages] = entry;
      $(target)
        .find(`#${prefix}_${attr.replace('.', '_attributes_')}`)
        .parents('.form-group')
        .addClass('error')
        .find('input')
        .after(
          $('<span>', {
            class: 'help-inline error-message',
            text: messages.join(', '),
          }),
        );
    });
    if (errors.base) {
      alert(errors.base.join(', '), 'error');
    }
  }
}
